export default __webpack_public_path__ + "static/media/Layer-1.13501755.jpg";